export default "/assets/images/filter-recommandation-CC.04be1673add07b81.jpg";